

// 饼图颜色盘
export const chartColorList = [
  'rgba(210, 89, 217, 1)',
  'rgba(255, 161, 54, 1)',
  'rgba(118, 68, 226, 1)',
  'rgba(10, 153, 81, 1)',
  'rgba(218, 42, 111, 1)',
  'rgba(255, 132, 86, 1)'
];

export const areaIcon = [
  'iconic_circle',
  'iconic_wubianxing',
  'iconic_sanjiaoxing',
  'iconic_liubianxing',
  'iconic_fangxing',
  'iconic_babianxing'
];

export const AreaChartColorList = [
  'rgba(210, 89, 217, 1)',
  'rgba(118, 68, 226, 1)',
  'rgba(10, 153, 81, 1)',
  'rgba(218, 42, 111, 1)',
  'rgba(255, 161, 54, 1)',
  'rgba(255, 132, 86, 1)'
];

